export enum CheckoutSessionStatus {
    InProgress = "in-progress",
    Finished = "finished",
}
